// src/i18n.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from '@/locale/lang/zh-CN'
import zhTW from '@/locale/lang/zh-TW'

Vue.use(VueI18n)

const messages = {
    'zh-CN': {
        message: zhCN
    },
    'zh-TW': {
        message: zhTW
    }
}

// 从存储中获取保存的语言或浏览器默认语言
const savedLang = localStorage.getItem('user-lang')
const browserLang = navigator.language
let lang = ''
if (messages[savedLang || browserLang]) {
    lang = savedLang || browserLang
} else {
    lang = 'zh-CN'
}

export default new VueI18n({
    locale: lang, // 默认语言
    fallbackLocale: 'zh-CN', // 回退语言
    messages
})
